<script lang="ts" setup>
import { OcticonButton } from '@sancare/typescript-commons'
import { ref } from 'vue'

import { useStore } from '@/store'
import { CodedMedicalAct } from '@/store/modules/medical-act/types'
import { PmsiTypeEnum } from '@/store/modules/settings/types'

const store = useStore()
const props = defineProps<{
  codedAct: CodedMedicalAct
  rhsId: number
}>()

const isLoading = ref(false)
const removeConfirm = ref(false)

async function removeAct() {
  isLoading.value = true
  await store.dispatch('medicalAct/removeMedicalAct', {
    id: props.codedAct.id,
    urlParams: {
      summaryUnitId: props.rhsId,
      pmsiType: PmsiTypeEnum.SMR,
    },
    startMut: { name: 'smrStay/startRefreshingGroupingResult' },
    successMut: {
      name: 'smrStay/updateMedicalActsSuccess',
    }
  })
  isLoading.value = false
  removeConfirm.value = false
}
</script>

<template>
  <div
    :id="codedAct.associatedAct.reference + '-medical-act'"
    class="row align-items-center g-0 hoverable-item"
  >
    <div class="col-auto me-auto">
      <div v-tooltip="codedAct.associatedAct.description || null">
        <strong>{{ codedAct.associatedAct.reference }}</strong>
      </div>
      <div
        v-if="codedAct.associatedAct.activity"
        class="act-data"
      >
        <span>Activité {{ codedAct.associatedAct.activity }}</span>
      </div>
    </div>
    <div class="col-auto">
      <v-dropdown
        :shown="removeConfirm"
      >
        <octicon-button
          :is-loading="isLoading"
          octicon-name="trash"
          :width="15"
          title="Supprimer l'acte"
          @click="removeConfirm = true"
        />
        <template #popper>
          <div class="p-3">
            <h4 class="title-light text-center">
              Êtes-vous sûr(e) ?
            </h4>
            <div class="text-center">
              <button
                class="btn btn-danger btn-padded"
                @click="removeAct()"
              >
                Confirmer
              </button>
            </div>
          </div>
        </template>
      </v-dropdown>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.act-data {
  font-size: .85rem;
}
</style>
